export default __webpack_public_path__ + "static/azuredatafactory-1785f7e7a16b36e801337747906ba2a3.svg";